var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-white pt-6 mt-6",staticStyle:{"height":"30vw"}},[_c('transition',{attrs:{"name":"bounce"}},[(_vm.message && !_vm.error)?_c('div',[_c('CheckMark',{staticClass:"p-6"}),_vm._v(" "),_c('h5',{staticClass:"text-5"},[_vm._v(_vm._s(_vm.message))])],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }